import React from 'react';
import DefaultContainer from '../../components/DefaultContainer';
import { ProtectionResumeItemCard, ServicePriceCard, Text } from '~/components';
import { useRoute, type RouteProp } from '@react-navigation/native';
import type { RootStackParamList } from '~/navigation/types';
import { useUserInfoStore } from '~/stores/userInfo';
import { formatMoney } from '~/utils';
import { incomeProtectionResumeItems } from '~/utils/services';
import GeneralConditionsButton from '../../components/GeneralConditionsButton';
import Footer from '../../components/Footer';

import AssurantLogoSvg from '~/assets/svgs/assurant-logo.svg';
import { GENERAL_CONDITIONS_LINK } from '~/scenes/IncomeProtection/constants';

const HiredInsuranceCoverageIncomeProtection: React.FC = () => {
  const contractedServices = useUserInfoStore(
    (state) => state.user?.contractedServices
  );

  const {
    params: { id: certificateCode },
  } =
    useRoute<
      RouteProp<
        RootStackParamList,
        'MarisaServicos_HiredInsuranceCoverageBagProtection'
      >
    >();

  const contractedService = contractedServices?.find(
    (service) => service.certificateCode === certificateCode
  );

  if (!contractedService) return null;

  return (
    <DefaultContainer type="income-protection" className="py-10">
      <Text className="text-gray-600 text-xl">Coberturas do Seguro</Text>

      <Text className="text-xs text-primary-600 mt-1 mb-6">Proteção Bolsa</Text>

      <ServicePriceCard value={formatMoney(contractedService.value)} />

      {incomeProtectionResumeItems.map((item, index) => (
        <ProtectionResumeItemCard data={item} key={index} />
      ))}

      <GeneralConditionsButton
        className="mb-10"
        url={GENERAL_CONDITIONS_LINK}
      />

      <Footer icon={AssurantLogoSvg} />
    </DefaultContainer>
  );
};

export default HiredInsuranceCoverageIncomeProtection;
